import React, { useEffect, useState } from "react";
import { CraeteVehicleWrapper } from "../style/createVehicle";
import API from "../../../api/axios";
import { APP_URLS } from "../../../api/url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { suggestionText } from "../../../config/constant";
import { APIError } from "../../../core/utils";
import CopyToClipboard from "react-copy-to-clipboard";
import copy from "../../../assets/Images/icons/faLink.svg";


const CreateBlockedChatMessages = () => {

  const navigate = useNavigate();

  const [languages, setLanguages] = useState([]);
  const [countries, setCountries] = useState([]);

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState({});

  useEffect(() => {
    const storedLanguages = JSON.parse(localStorage.getItem("languages") || "[]");
    const storedCountries = JSON.parse(localStorage.getItem("countries") || "[]");

    setLanguages(storedLanguages);
    setCountries(storedCountries);

    // Initialize name fields only after setting languages
    const initialNames = {};
    storedLanguages.forEach((lang) => {
      initialNames[lang.code] = "";
    });
    setName(initialNames);
  }, []);

  const handleTitleChange = (val, code) => {
    setName((prev) => ({ ...prev, [code]: val }));
  };

  const resetForm = () => {
    const reset = {};
    languages.forEach((lang) => {
      reset[lang.code] = "";
    });
    setName(reset);
  };

  const submitForm = () => {
    let errorMessage = "";
    if (!name["en"] && !name["fr"]) {
      errorMessage = "Message in English and French is mandatory";
    } else if (!name["en"]) {
      errorMessage = "Please provide message in English";
    } else if (!name["fr"]) {
      errorMessage = "Please provide message in French";
    }

    if (errorMessage) {
      toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    const data = {
      name,
      type: suggestionText.BLOCKED_CHAT_MESSAGES,
    };

    if (!loading) {
      setLoading(true);
      API.post(APP_URLS.ADD_SUGGESTION_TEXT, data)
        .then((res) => {
          setLoading(false);
          const resp = res.data;
          if (resp.success) {
            toast.success("Blocked chat message added successfully.", {
              position: toast.POSITION.TOP_RIGHT,
            });
            navigate("/translation/blocked-chat-message");
            resetForm();
          } else {
            toast.error(resp.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(APIError(error), {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  };

  return (
    <CraeteVehicleWrapper>
      <div className="mt-2">
        <div
          className="backContainer ms-4"
          onClick={() => navigate("/translation/blocked-chat-message")}
        >
          <span className="backButton">x</span>
          <span className="px-3 backButton">|</span>
          <span className="backButton">Cancel</span>
        </div>
      </div>

      <div className="headerContainer">
        <h1>CREATE BLOCKED CHAT MESSAGES</h1>
      </div>

      <div className="d-flex justify-content-between save-btn mt-3">
        <p className="fieldLabel">Title</p>
        <button
          className={`add-button ${loading ? "disabled" : ""}`}
          onClick={submitForm}
          disabled={loading}
        >
          Save
        </button>
      </div>

      <div className="row input-fileds">
        {languages.map((language) => {
          const itemCode = language.code;
          const flag = countries.find(
            (o) => o.id === language.country_id
          )?.flag_thumbnail;

          return (
            <div className="col-md-4" key={language.id}>
              <div className="col-md-12 mt-3">
                <label htmlFor={`title-${itemCode}`} className="form-label">
                  <span className="countryIcon px-2">
                    <img
                      src={flag}
                      alt=""
                      className="countryflag"
                      title={language.name}
                    />
                  </span>
                  <span className="langName">{itemCode}</span>
                </label>
                <textarea
                  id={`title-${itemCode}`}
                  name={`title-${itemCode}`}
                  className="form-control departmentFields"
                  rows={5}
                  value={name[itemCode] || ""}
                  onChange={(e) => handleTitleChange(e.target.value, itemCode)}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="suggested-labels">
        <p className="fieldLabel">Suggested labels</p>
        <ul>
          <li>
            <span>{"{{username}}"}</span>
            <CopyToClipboard text={"{{username}}"} onCopy={() => toast("Text Copied")}>
              <img className="ms-2" src={copy} alt="" />
            </CopyToClipboard>
          </li>
          <li>
            <span>{"{{ad}}"}</span>
            <CopyToClipboard text={"{{ad}}"} onCopy={() => toast("Text Copied")}>
              <img className="ms-2" src={copy} alt="" />
            </CopyToClipboard>
          </li>
        </ul>
      </div>
    </CraeteVehicleWrapper>
  );
};

export default CreateBlockedChatMessages;
